import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { v4 as uuidv4 } from "uuid";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { IMucThuKhacSinhVienGanThemRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienGanThemRequest";
import { IMucThuKhacSinhVienSaveRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IMucThuKhacSinhVienUpdateSoTienRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienUpdateSoTienRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IMucThuKhacSinhVien } from "../../../model/respone/chung-tu/IMucThuKhacSinhVien";

import {
  eMucThuActionIds,
  IMucThuActionTypes,
} from "../../action-types/muc-thu/IMucThuActionTypes";
import { rootActions } from "../../actions/rootActions";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";

export function* mucThuSaga(): any {
  yield takeLatest(eMucThuActionIds.LOAD_HOCSINH_START, loadWorker);
  yield takeLatest(eMucThuActionIds.LOAD_MUCTHUKHAC_START, loadMucThuWorker);
  yield takeLatest(
    eMucThuActionIds.CREATE_MUCTHUKHAC_START,
    createMucThuKhacStart
  );
  yield takeLatest(
    eMucThuActionIds.CREATE_AND_DUYET_MUCTHUKHAC_START,
    createAndDuyetMucThuStart
  );
  yield takeLatest(
    eMucThuActionIds.GAN_THEM_AND_DUYET_MUCTHUKHAC_START,
    ganThemAndDuyetMucThuStart
  );
  yield takeEvery(eMucThuActionIds.DUYET_MUCTHUKHAC_START, duyetMucThuStart);
  yield takeEvery(
    eMucThuActionIds.HUYDUYET_MUCTHUKHAC_START,
    huyDuyetMucThuStart
  );
  yield takeEvery(
    eMucThuActionIds.DELETE_MUCTHUKHAC_START,
    deleteMucThuKhacStart
  );
  yield takeEvery(
    eMucThuActionIds.HUY_VA_GO_MUCTHUKHAC_START,
    huyVaGoMucThuStart
  );
  yield takeEvery(eMucThuActionIds.UPDATE_MUCTHUKHAC_START, updateSoTienStart);
  yield takeLatest(eMucThuActionIds.IMPORT_START, importStart);
  yield takeLatest(eMucThuActionIds.SAVE_IMPORT_START, saveImportStart);
  yield takeLatest(eMucThuActionIds.IMPORT_HUYDUYET_START, importHuyDuyetStart);
  yield takeLatest(
    eMucThuActionIds.SAVE_IMPORT_HUYDUYET_START,
    saveImportHuyDuyetStart
  );
}

function* loadWorker(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienApi.SelectByLops,
    action.payload as ISinhVienSelectByLopsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.LOAD_HOCSINH_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.LOAD_HOCSINH_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* loadMucThuWorker(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectByLops,
    action.payload as IMucThuKhacSinhVienSelectByLopsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.LOAD_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.LOAD_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* createMucThuKhacStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Create,
    action.payload as IMucThuKhacSinhVienSaveRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* createAndDuyetMucThuStart(action: IMucThuActionTypes): any {
  const request = action.payload as IMucThuKhacSinhVienSaveRequest;

  const createRes: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Create,
    request
  );
  if (!createRes.is_success) {
    yield put(
      rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_ERRR(
        createRes.message ?? "Có lỗi"
      )
    );
    return;
  }
  yield put(
    rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_SUCCESS(createRes.data)
  );

  const all: IMucThuKhacSinhVien[] = createRes.data ?? [];
  const idSvSet = new Set(request.id_svs);
  const idsToDuyet = all
    .filter(
      (x) =>
        idSvSet.has(x.id_sv) &&
        x.id_thu_chi === request.id_thu_chi &&
        !x.locked_duocthu
    )
    .map((x) => x.id);

  if (idsToDuyet.length === 0) return;

  yield put(
    rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_START({
      payload: idsToDuyet,
      process_id: uuidv4(),
    })
  );
}

function* ganThemAndDuyetMucThuStart(action: IMucThuActionTypes): any {
  const request = action.payload as IMucThuKhacSinhVienGanThemRequest;

  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.GanThem,
    request
  );
  if (!res.is_success) {
    yield put(
      rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_ERRR(
        res.message ?? "Có lỗi"
      )
    );
    yield put(rootActions.mucThu.mucThu.SHOW_GAN_THEM_MODAL(false));
    return;
  }
  yield put(rootActions.mucThu.mucThu.SHOW_GAN_THEM_MODAL(false));
  yield put(rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_SUCCESS(res.data));

  const all: IMucThuKhacSinhVien[] = res.data ?? [];
  const idSvSet = new Set(request.id_svs);
  const idsToDuyet = all
    .filter(
      (x) => idSvSet.has(x.id_sv) && x.id_thu_chi === request.id_thu_chi
    )
    .map((x) => x.id);

  if (idsToDuyet.length === 0) return;

  yield put(
    rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_START({
      payload: idsToDuyet,
      process_id: uuidv4(),
    })
  );
}

function* duyetMucThuStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.DuyetAsync,
    action.payload as IProcessRequest<number[]> & { id_lop_tcs?: number[] }
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* huyDuyetMucThuStart(action: IMucThuActionTypes): any {
  const request = action.payload as IProcessRequest<number[]>;
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.HuyDuyetAsync,
    request
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.HUYDUYET_MUCTHUKHAC_SUCCESS(res.data));
    yield put(
      rootActions.thuPhi.thuPhi.LOAD_MUC_THU_KHAC_START_BY_MUCTHUID(
        request.payload
      )
    );
  } else {
    yield put(
      rootActions.mucThu.mucThu.HUYDUYET_MUCTHUKHAC_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* deleteMucThuKhacStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Deletes,
    action.payload as IIdsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.DELETE_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.DELETE_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

// Hủy và gỡ khoản thu: bỏ duyệt trước (Deletes yêu cầu chưa duyệt) rồi xóa mức thu. Công nợ được tính lại
// ở bước bỏ duyệt (DuyetMucThuAsync false); khoản đã bỏ duyệt không còn tính vào phải-nộp nên xóa an toàn.
function* huyVaGoMucThuStart(action: IMucThuActionTypes): any {
  const request = action.payload as IProcessRequest<number[]>;
  // 1. Bỏ duyệt (có process tracking + tính lại công nợ).
  const huyRes: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.HuyDuyetAsync,
    request
  );
  if (!huyRes.is_success) {
    yield put(
      rootActions.mucThu.mucThu.HUYDUYET_MUCTHUKHAC_ERRR(
        huyRes.message ?? "Có lỗi"
      )
    );
    return;
  }
  // 2. Gỡ (xóa) mức thu — giờ đã bỏ duyệt nên Deletes không báo "đã duyệt".
  const delRes: IBaseRespone = yield call(mucThuKhacSinhVienApi.Deletes, {
    ids: request.payload,
  } as IIdsRequest);
  if (!delRes.is_success) {
    yield put(
      rootActions.mucThu.mucThu.DELETE_MUCTHUKHAC_ERRR(
        delRes.message ?? "Có lỗi"
      )
    );
    return;
  }
  // Xong: tái dùng HUYDUYET_SUCCESS (need_reload + clear selection) + làm mới màn Thu phí theo mức thu id.
  yield put(rootActions.mucThu.mucThu.HUYDUYET_MUCTHUKHAC_SUCCESS(undefined));
  yield put(
    rootActions.thuPhi.thuPhi.LOAD_MUC_THU_KHAC_START_BY_MUCTHUID(
      request.payload
    )
  );
}

function* updateSoTienStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.UpdateSoTien,
    action.payload as IMucThuKhacSinhVienUpdateSoTienRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.UPDATE_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.UPDATE_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* importStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Import,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.IMPORT_SUCESS(res.data));
  } else {
    yield put(rootActions.mucThu.mucThu.IMPORT_ERROR(res.message ?? "Có lỗi"));
  }
}

function* saveImportStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SaveImport,
    action.payload as { cache_id: string; process_id: string }
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.SAVE_IMPORT_SUCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.SAVE_IMPORT_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* importHuyDuyetStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.ImportHuyDuyet,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.IMPORT_HUYDUYET_SUCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.IMPORT_HUYDUYET_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* saveImportHuyDuyetStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SaveImportHuyDuyet,
    action.payload as { cache_id: string; process_id: string }
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.SAVE_IMPORT_HUYDUYET_SUCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.SAVE_IMPORT_HUYDUYET_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
